export class Citasview {
    DoctorId: number;
    TareaId: number;
    date?: string;
    Hora?: Date;
    BajaId: number;
    Smeid: number
    TrabajadorId: number;
    EmpresaId: string;
    Medico: string;
    TareaNombre: string;
    APELLIDOS: string;
}